<script>
import SuccessIcon from "@/assets/icons/SuccessIcon.svg"

export default {
  name: "SuccessModal",
  props: {
    value: {
      Boolean, default() {
        return false
      }
    },
    modelId: {
      String, default() {
        return null
      }
    },
    name: {
      String, default() {
        return null
      }
    },
    action: {
      type: String, default() {
        return 'created'
      }
    },
    messageKey: {
      String, default() {
        return null
      }
    }
  },
  data() {
    return {
      SuccessIcon,
    }
  },
  computed: {
    translationKey() {
      if (this.messageKey) {
        return this.messageKey
      }
      return this.action === 'updated'
          ? 'unloads.messages.updated_successfully_{something}_{id}'
          : 'unloads.messages.created_successfully_{something}_{id}'
    },
    modalTitleMessage() {
      return this.$t(this.translationKey, {
        something: this.lodash.startCase(this.name),
        id: this.modelId
      })
    },
  },
  methods: {
    onCloseClick(event) {
      this.$emit('close-clicked', event)
    }
  }
}
</script>

<template>
  <b-modal
      v-model="value"
      centered
      hide-header
      hide-footer
      size="md"
      no-close-on-backdrop
  >
    <div class="text-center">
      <img class="mb-2" :src="SuccessIcon" alt="Success Icon"/>
      <h3>{{ modalTitleMessage }}</h3>
      <b-button
          variant="white"
          class="custom-button"
          @click="onCloseClick"
      >{{  $t('Close') }}</b-button>
    </div>
  </b-modal>
</template>

<style scoped lang="scss">
::v-deep {
  button {
    font: 600 16px Lato, sans-serif;

    &.btn {
      &.custom-button {
        background-color: #F2F4F7 !important;
        color: #182230 !important;
      }
    }

  }
}
p {
  font-size: 14px;
  line-height: 24px;
}


</style>
